import { render } from "./Tab2.vue?vue&type=template&id=d9cd6f8a&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"

import "./Tab2.vue?vue&type=style&index=0&id=d9cd6f8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9cd6f8a"]])

export default __exports__